import _ from 'lodash'

const SITE_GAP_CONIG = {
    main: _.select( 'main' ),
    header: _.select( '.c-site-header' ),
    gapSections: _.selectAll( '.c-section--site-gap' ),
    breadcrumbs: _.select( '.c-breadcrumbs--position-overlay' )
}

export default SITE_GAP_CONIG